// extracted by mini-css-extract-plugin
module.exports = {"latest-list":"styles-m__latest-list__28ZxZ","li-list":"styles-m__li-list__nPqiq","ul-grid":"styles-m__ul-grid__2ElHf","footer-title":"styles-m__footer-title__2CKMR"};